import * as Yup from "yup";
import {toast} from "react-toastify";
import React, {useRef, useState} from "react";
import messageTypes from "../../../constants/MessagesTypes";
import {getBank, getBanks, newBank} from "../../../services/Bank";
import {Form} from "@unform/web";
import CustomButton from "../../../components/Form/Button";
import {Link, useHistory} from "react-router-dom";
import InputSelectAutoComplete from "../../../components/Form/InputSelectAutoComplete";
import InputMask from "../../../components/Form/InputMask";
import {IoMdCheckmark} from "react-icons/io";
import {FaRegMoneyBillAlt} from "react-icons/fa";
import {BiArrowBack} from "react-icons/bi";
import Fieldset from "../../../components/Fieldset";
import CkeckboxInput from "../../../components/Form/Checkbox";
import {InputAdornment} from "@material-ui/core";
import {actions} from "../../../redux/actions";
import {useDispatch} from "react-redux";
import {getBrokerOptions, normalizeBrokerValue} from "../../../utils/broker";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    PageHeader as TradingPageHeader,
    TradingCard,
} from "../../Trading/styles";
import {
    StyledFormWrapper,
    CardTitle,
    ButtonContainer,
    FormRow,
} from "../../Trading/New/styles";
import styled from "styled-components";

const BankNewPageHeader = styled(TradingPageHeader)`
    z-index: 2;
    margin-bottom: 28px;

    @media (min-width: 768px) {
        margin-bottom: 36px;
    }
`;

const BankNewNarrow = styled.div`
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    position: relative;
    z-index: 2;
    margin-top: 16px;

    @media (min-width: 576px) {
        margin-top: 20px;
    }

    @media (min-width: 992px) {
        margin-top: 24px;
    }
`;

const DarkFieldsetArea = styled.div`
    fieldset {
        border-color: rgba(242, 146, 5, 0.35) !important;
        color: #e0e0e0 !important;
    }

    legend .MuiFormHelperText-root,
    legend .MuiFormHelperText-root.Mui-focused {
        color: #f29205 !important;
    }

    .MuiFormControlLabel-label {
        color: #e0e0e0 !important;
    }

    .currency-type-options .row {
        margin-left: -6px;
        margin-right: -6px;
    }

    .currency-type-options .row > [class*='col-'] {
        padding-left: 6px;
        padding-right: 6px;
    }

    @media (max-width: 767px) {
        .currency-type-options .MuiFormControlLabel-label span {
            font-size: 0.9rem;
        }
    }
`;

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const saveBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

export default function NewBank() {
    const [loading, setLoading] = useState(false);
    const [coinType, setCoinType] = useState('R$');
    const formRef = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const brokerOptions = getBrokerOptions();

    async function handleSaveBank(data) {
        try {
            const initialValue = data.initialValue.replace(/[^0-9,-]*/g, '').replace(',', '.');
            if (initialValue === '0.00') {
                toast.warning(t('bank_warning_value_initial_required'));
                return;
            }

            if (loading) {
                return;
            }

            setLoading(true);
            formRef.current.setErrors({});
            const resolvedBroker = normalizeBrokerValue(data.broker);
            const schema = Yup.object().shape({
                initialValue: Yup.string().required(t('input_required')),
                broker: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const formData = new FormData();
            formData.append('initialValue', initialValue);
            formData.append('investmentRate', data.investmentRate);
            formData.append('broker', resolvedBroker);
            formData.append('coinType', coinType);
            const response = await newBank(formData);

            if (response && response.status === 200) {
                toast.success(messageTypes.NEW_BANK);
                try {
                    const d = await getBank();
                    if (d) {
                        dispatch(actions.updateBank(d));
                    }
                    const banks = await getBanks();
                    if (banks) {
                        dispatch(actions.setBanks(banks));
                    }
                } catch (e) {
                    /* Topbar faz getBank nos efeitos; seguimos para o dashboard */
                }
                history.push('/dashboard');
            } else {
                toast.error(messageTypes.ERROR);
            }
            setLoading(false);

        } catch (err) {
            setLoading(false);
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    return (
        <TradingWrapper>
            <DivDiagonal />
            <ContentArea>
                <BankNewPageHeader>
                    <h1>
                        <i className="fas fa-plus-circle" aria-hidden="true"/> {t('bank_text_add')}
                    </h1>
                </BankNewPageHeader>

                <BankNewNarrow>
                    <TradingCard>
                        <StyledFormWrapper>
                            <Form ref={formRef} onSubmit={handleSaveBank}>
                                <CardTitle>
                                    <i className="fas fa-clipboard-list" aria-hidden="true"/> {t('bank_text_info')}
                                </CardTitle>

                                <FormRow>
                                    <InputSelectAutoComplete
                                        name="broker"
                                        label={t('bank_broker') + ' *'}
                                        options={brokerOptions}
                                        freeSolo
                                        filterOptions={(options, state) => {
                                            const inputValue = state.inputValue.trim().toLowerCase();

                                            if (!inputValue) {
                                                return options;
                                            }

                                            return options.filter((option) =>
                                                option.value.toLowerCase().includes(inputValue)
                                            );
                                        }}
                                    />
                                </FormRow>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <FormRow>
                                            <InputMask
                                                type="text"
                                                name="initialValue"
                                                label={t('bank_initial_value') + ' *'}
                                                mask={'currency'}
                                                defaultValue={null}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">{coinType}</InputAdornment>,
                                                }}
                                            />
                                        </FormRow>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormRow>
                                            <InputMask
                                                type="text"
                                                name="investmentRate"
                                                label={t('bank_investment_rate')}
                                                mask={'percent'}
                                                defaultValue={(3).toFixed(2)}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position={'end'}>%</InputAdornment>,
                                                }}
                                            />
                                        </FormRow>
                                    </div>
                                </div>

                                <FormRow>
                                    <DarkFieldsetArea>
                                        <Fieldset iconLegend={<FaRegMoneyBillAlt/>} textLegend={t('bank_type_currency')} className="scheduler-border">
                                            <div className="form-check currency-type-options">
                                                <CkeckboxInput
                                                    id="coinType"
                                                    name="coinType"
                                                    setValue={setCoinType}
                                                    labelLight
                                                    value={'R$'}
                                                    optionColClass="col-12 col-sm-6 col-md-4 mb-2 mb-md-0"
                                                    options={[
                                                        {name: 'coinTypeReal', value: 'R$', label: t('currency_real')},
                                                        {name: 'coinTypeDolar', value: '$', label: t('currency_usd')},
                                                        {name: 'coinTypeDolar', value: '€', label: t('currency_euro')},
                                                    ]}
                                                />
                                            </div>
                                        </Fieldset>
                                    </DarkFieldsetArea>
                                </FormRow>

                                <ButtonContainer>
                                    <Link to="/bank/view" style={{ textDecoration: 'none' }}>
                                        <CustomButton
                                            variant="outlined"
                                            className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                                            startIcon={<BiArrowBack/>}
                                            style={backBtnStyle}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            {t('btn_back')}
                                        </CustomButton>
                                    </Link>
                                    <CustomButton
                                        className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                                        style={saveBtnStyle}
                                        loading={loading}
                                        type="submit"
                                        startIcon={<IoMdCheckmark/>}
                                        onMouseEnter={(e) => {
                                            if (!loading) {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                        }}
                                    >
                                        {t('btn_save')}
                                    </CustomButton>
                                </ButtonContainer>
                            </Form>
                        </StyledFormWrapper>
                    </TradingCard>
                </BankNewNarrow>
            </ContentArea>
        </TradingWrapper>
    );
}
